import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { RegistrationModel, ResendOtp } from 'src/app/modules/registration/models/RegistrationModel';
import { environment } from 'src/environments/environment';
import { BaseHttpService } from '../baseService/base-http-service';
import { DeleteRegistration } from 'src/app/modules/registration/models/CheckOtpModel';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private baseUrl = environment.baseUrl
  private camBaseUrl = environment.camBaseUrl;
  constructor(private http: HttpClient, private baseService: BaseHttpService) { }

  RegisterCorporate(corporateData: RegistrationModel): Observable<any> {
    
    const url = `${this.camBaseUrl}/api/Account/Register-company`;
    const headers = {
      'Content-Type': 'application/json',
    };
    return this.baseService.request<any>('POST', url, corporateData, headers).pipe(map(response => {
      return response;
    })
    );
  }


  CompleteRegistration(corporateData: RegistrationModel): Observable<any> {
    const url = `${this.baseUrl}/corporate/Account/Complete-registration`;
    const tokenType = localStorage.getItem('token_type') || '';
    const accessToken = localStorage.getItem('access_token') || '';
    const expiresIn = localStorage.getItem('expires_in') || '';
    const scope = localStorage.getItem('scope') || '';
    const sessionId = localStorage.getItem('session_id') || '';
    const token = localStorage.getItem('QlAccessToken');
    const headers = {
      'Content-Type': 'application/json',

    };

    return this.baseService.request<any>('POST', url, corporateData, headers).pipe(map(response => {
      return response;
    }));
  }


  ResendOtp(ResendOtp: ResendOtp): Observable<any> {
    const tokenType = localStorage.getItem('token_type') || '';
    const uid = sessionStorage.getItem('UID') || '';
    const accessToken = localStorage.getItem('access_token') || '';
    const expiresIn = localStorage.getItem('expires_in') || '';
    const scope = localStorage.getItem('scope') || '';
    const sessionId = localStorage.getItem('session_id') || '';
    const token = localStorage.getItem('QlAccessToken');
    const headers = {
      'Content-Type': 'application/json',
      "AccessToken": accessToken,
      "SaaSessionId": sessionId
    };

    const url = `${this.baseUrl}/corporate/Account/ResendOtp?uid=${uid}`;

    return this.baseService.request<any>('POST', url, ResendOtp, headers).pipe(map(response => {
      return response;
    }));
  }



  DeleteRegistration(DeleteRegistration: DeleteRegistration): Observable<any> {
    const tokenType = localStorage.getItem('token_type') || '';
    const uid = sessionStorage.getItem('UID') || '';
    const headers = {
      'Content-Type': 'application/json',
    };
    const url = `${this.baseUrl}/corporate/Account/DeleteRegistration?uid=${uid}`;

    return this.baseService.request<any>('POST', url, DeleteRegistration, headers).pipe(map(response => {
      return response;
    }));
  }

  VerifyELM(ELMPAYLOAD: any): Observable<any> {
    const tokenType = localStorage.getItem('token_type') || '';
    const uid = sessionStorage.getItem('UID') || '';
    const accessToken = localStorage.getItem('access_token') || '';
    const expiresIn = localStorage.getItem('expires_in') || '';
    const scope = localStorage.getItem('scope') || '';
    const sessionId = localStorage.getItem('session_id') || '';
    const token = localStorage.getItem('QlAccessToken');
    const headers = {
      'Content-Type': 'application/json',
      'AccessToken': `${accessToken}`,
      'Expires-In': expiresIn,
      'SaaSessionId': sessionId,
      'Scope': scope,
      Authorization: 'Bearer ' + token
    };
    const url = `${this.baseUrl}/api/Cart/get-elm-profile?Lang=&uid=${uid}`;
    return this.baseService.request<any>('POST', url, ELMPAYLOAD, headers).pipe(map(response => {
      return response;
    }));
  }

verifyHCaptcha(token: string): Observable<any> {
    const uid = sessionStorage.getItem('UID') || '';
    const tokenType = localStorage.getItem('token_type') || '';
    const accessToken = localStorage.getItem('access_token') || '';
    const expiresIn = localStorage.getItem('expires_in') || '';
    const scope = localStorage.getItem('scope') || '';
    const sessionId = localStorage.getItem('session_id') || '';

    const headers = {
      'Content-Type': 'application/json',
      'AccessToken': accessToken,
      'Expires-In': expiresIn,
      'SaaSessionId': sessionId,
      'Scope': scope,
      'Authorization': 'Bearer ' + (localStorage.getItem('QlAccessToken') || '')
    };

    const payload = { token };

    const url = `${this.baseUrl}/api/Auth/verifyhCaptcha`;
      
    return this.http.post(url, payload, { headers });
  }VerifyELMV1(body: any): Observable<any> {
  const accessToken = localStorage.getItem('access_token') || '';
  const sessionId = localStorage.getItem('session_id') || '';
    const headers = {
      'Content-Type': 'application/json',
      'AccessToken': `${accessToken}`,
      'SaaSessionId':`${sessionId}`

    };
    const url = `${this.baseUrl}/api/Cart/v1/get-elm-profile`;
    return this.baseService.request<any>('POST', url, body, headers).pipe(map(response => {
      return response;
    }));
  }


}
